export const API_URL = import.meta.env.VITE_API;
export const APP_ENV = import.meta.env.VITE_ENV;
export const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLEAPIKEY;
